import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { trigger } from 'swr';

import useMatch from 'app/hooks/match';
import { ReactComponent as AlertIcon } from '../../collections/detail/delete/alert.svg';
import { CurrentCollectionContext } from '../../collections/current-collection-context';
// import { destroyStory } from '../actions';
import { setCheckmark } from '../../ui/actions';
import { useEntity, useEntityActionCreators } from '../../entities/hooks';
import { useHistory } from 'react-router-dom';
import { useRouteFromEntityParams } from '../../collections/hooks';
import DeleteCollectionModal from '../../collections/detail/delete/modal';
import { destroyStory } from 'stories/api';
import useLocation from 'app/hooks/location';
import { useFirstTimeUserFlowVisible } from 'stories/hooks/index';
import { togglefirstTimeUserFlowVisible } from 'stories/actions';

const DeleteModal = props => {
  let {
    params: { id },
  } = useMatch();
  id = props?.storyID || id
  const { pathname } = useLocation();
  const { currentCollection } = useContext(CurrentCollectionContext);
  const { replace } = useHistory();
  const { receiveDeletion } = useEntityActionCreators();
  const { entity } = useEntity({ id, type: 'stories' });
  const dispatch = useDispatch()
  const isFirstTimeUser = useFirstTimeUserFlowVisible()
  const route = useRouteFromEntityParams({
    type: currentCollection.type,
    id: currentCollection.id,
  });
  const [loading, setLoading] = useState(false);

  const onDestroyClick = () => {
    setLoading(true);
    let replaceURL = `/child-journals/${currentCollection.id}`;
    if (pathname.includes('/tell_a_story/') && entity?.['child-journal-story-request']?.id)
      replaceURL = `/tell_a_story/${entity?.['child-journal-story-request']?.id}`
    destroyStory(id, currentCollection.id).then(() => {
      if (isFirstTimeUser)
        dispatch(togglefirstTimeUserFlowVisible(false))
      receiveDeletion({ entityType: 'stories', id });
      trigger(route);
      replace(replaceURL);

      props.setCheckmark({ message: 'Deleted' });
    });
  };

  return (
    <DeleteCollectionModal
      onClose={props.onClose}
      onCancelClick={props.onClose}
      cancelText="Cancel"
      destroyText="Delete Now"
      onDestroyClick={onDestroyClick}
      headerIcon={<AlertIcon />}
      bodyTitle={`Delete the story "${entity.title}"?`}
      // bodyText={`Deleting "${entity.title}" will delete it from all Memoirs.`}
      disabled={loading}
    />
  );
};

DeleteModal.propTypes = {
  destroyStory: PropTypes.func.isRequired,
  setCheckmark: PropTypes.func.isRequired,
};

export default connect(null, { destroyStory, setCheckmark })(DeleteModal);
